// Dashboard.jsx
import LatestDeals from './dashboard-modues/LatestDeals';
import UserCRMSummary from './dashboard-modues/UserCRMSummary';
import RecommendedInvestorsList from './dashboard-modues/RecommendedInvestorsList';
import DashboardOnboarding from './dashboard-modues/DashboardOnboarding';
import DataExportPanel from './dashboard-modues/DataExportPanel';

const Dashboard = () => {
  return (
    <>
      <DashboardOnboarding />
      <div className="flex flex-wrap lg:flex-nowrap gap-8">
        <div className="flex flex-col gap-8 w-full lg:w-1/2">
          <UserCRMSummary />
          <DataExportPanel />
          <RecommendedInvestorsList />
        </div>
        <div className="w-full lg:w-1/2">
          <LatestDeals />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
